import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { StudentFacade } from '../facades/student.facade';

export function studentCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const studentFacade = inject(StudentFacade);
        studentFacade.clear();

        return true;
    };
}
